export default "__VITE_ASSET__BJbcdSES__"